/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { SystemStyleObject, Theme } from "@mui/system";

export const aiLabPromptForgeStyles = {
  editorContainer: {
    border: "1px solid",
    borderColor: "divider",
    borderRadius: 1,
    overflow: "visible",
  },
  streamingContainer: (minHeight: number): SystemStyleObject<Theme> => ({
    minHeight,
    overflowY: "auto",
    border: "1px solid",
    borderColor: "grey.400",
    p: 1.5,
    bgcolor: "grey.50",
  }),
};
